import { useSearchAlarm } from './use-search-alarm';
import { SearchAlarmOverlay } from './search-alarm-overlay';

/**
 * Mounted once near the app root (cpanel `SearchAlarmMonitor`): runs the
 * in-search poll and shows the page-wide alarm while an order has been
 * searching for a courier longer than 4 minutes at night. `enabled` gates it
 * to the roles and sessions that should hear it.
 */
export function SearchAlarmMonitor({ enabled }: { enabled: boolean }) {
  const overdue = useSearchAlarm(enabled);
  return <SearchAlarmOverlay overdue={overdue} />;
}
